import { TagsInput as MantineTagsInput } from "@mantine/core";
import FilterLayout from "./FilterLayout";

interface Props {
  filterName: string;
  values?: string[];
  onChange: (values: string[]) => void;
}

const TagsInput = ({ filterName, onChange, values = [] }: Props) => {
  return (
    <FilterLayout filterName={filterName}>
      <MantineTagsInput
        placeholder="Filter values"
        size="xs"
        onChange={onChange}
        clearable
        value={values}
      />
    </FilterLayout>
  );
};

export default TagsInput;
